import React, { useState } from 'react';
import axios from "axios";
import './App.css';

function App() {
  const [productName, setProductName] = useState('');
  const [productList, setProductList] = useState([]);
  const [randomCount, setRandomCount] = useState(0);
  const [randomList, setRandomList] = useState([]);

  const [data, setData] = React.useState();
  const url = process.env.REACT_APP_API_URL;

  const GetData = () => {
		axios.get(url).then((res) => {
			setData(res.data);
		});
	};

  // 商品を追加
  const handleAddProduct = () => {
    if (productName.trim() !== '') {
      setProductList([...productList, productName]);
      setProductName('');
    }
  };

  // 商品を削除
  const handleRemoveProduct = (index) => {
    const updatedList = productList.filter((_, i) => i !== index);
    setProductList(updatedList);
  };

  // ランダム抽出
  const handleRandomSelect = () => {
    const count = parseInt(randomCount, 10);
    if (count > 0 && count <= productList.length) {
      const shuffled = [...productList].sort(() => 0.5 - Math.random());
      setRandomList(shuffled.slice(0, count));
    }
  };

  return (
    <div className="app-container">
      <header className="header">
        <h1>ランダムおせちメーカー</h1>
      </header>

      <div className="input-section">
        <input
          type="text"
          placeholder="商品名を入力"
          value={productName}
          onChange={(e) => setProductName(e.target.value)}
          className="input-box"
        />
        <button onClick={handleAddProduct} className="button add-button">追加</button>
      </div>

      <div className="product-list">
        {productList.length === 0 ? (
          <p className="placeholder">商品がありません</p>
        ) : (
          productList.map((product, index) => (
            <div key={index} className="product-item">
              <span>{product}</span>
              <button onClick={() => handleRemoveProduct(index)} className="button delete-button">削除</button>
            </div>
          ))
        )}
      </div>

      <div className="random-section">
        <input
          type="number"
          placeholder="抽出個数を入力"
          value={randomCount}
          onChange={(e) => setRandomCount(e.target.value)}
          className="input-box"
        />
        <button onClick={handleRandomSelect} className="button extract-button">抽出</button>
      </div>

      <div className="random-list">
        {randomList.length === 0 ? (
          <p className="placeholder">抽出された商品がありません</p>
        ) : (
          randomList.map((product, index) => (
            <div key={index} className="random-item">
              {product}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default App;
